export const BPM_ROLES_MAIN_PATH = "/settings-menu/bpm-roles";
